import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Services/TradeFinance/components/SectionDisclaimer/SectionDisclaimer.module.scss';

const cn = classNames.bind(styles);

const SectionDisclaimer = (): ReactElement => {
  return (
    <section className={cn('disclaimer')}>
      <div className={cn('container')}>

        <h2 className={cn('disclaimer__heading')}>
          Disclamer
        </h2>

        <div className={cn('disclaimer__content')}>
          <div className={cn('disclaimer__container')}>
            <p className={cn('disclaimer__paragraph')}>
              DP World Trade Finance is a fintech platform (“the Platform”) owned by
              DP World Logistics FZE which brings together importers, exporters, and
              logistics companies from around the world (who seek trade finance) together
              with financial institutions and other providers of trade finance.
            </p>
            <p className={cn('disclaimer__paragraph')}>
              In order to access the Platform, you must confirm your jurisdiction.
              For UAE based persons (including the Dubai International Financial Centre (DIFC)),
              the Platform is operated by DP World Financial Services Limited. For those who
              are operating outside the United Arab Emirates, you will receive your services
              through the Platform operated by DP World Service Limited, and entity incorporated
              in Cayman Islands. DP World Financial Services Limited is an Authorized firm
              incorporated in the DIFC and regulated by the Dubai Financial Services Authority
              (DFSA). For persons outside the UAE, the Platform is operated by DP World
              Services Limited, an entity incorporated in the Cayman Islands. You will receive
              services and enter into an agreement with either DP World Financial Services
              Limited (DIFC) or DP World Services Limited (Cayman), subject to the jurisdiction
              you are located.
            </p>
          </div>
          <div className={cn('disclaimer__container')}>
            <div className={cn('disclaimer__paragraph')}>
              <h4 className={cn('disclaimer__paragraph-heading')}>
                DP World Financial Services Limited
              </h4>
              DP World Financial Services Limited is incorporated in the Dubai International
              Financial Centre (DIFC) and is regulated by the Dubai Financial Services Authority
              (DFSA) to offer the financial services of ‘Arranging Credit’ and “Providing Credit”
              for client who is based in the UAE. These Financial Services are available through
              the Platform it operates. The Platform is operated by DP World Financial Services
              Limited whose registered office is at 811, Level 8, Burj Daman, DIFC, Al Moustaqbal
              Street, Dubai, United Arab Emirates.
            </div>
            <div className={cn('disclaimer__paragraph')}>
              <h4 className={cn('disclaimer__paragraph-heading')}>
                DP World Services Limited
              </h4>
              DP World Services Limited offers the service of ‘Arranging Credit’ to clients 
              who are outside of the United Arab Emirates through its Platform. For any client 
              who is interested to obtain the financial service of providing credit, you can 
              submit your application on DP World Trade Finance. DP World Services Limited is 
              incorporated in Cayman Island and is an exempted company with its registered 
              office at c/o Walkers Corporate Limited, 190 Elgin Avenue, George Town, Grand 
              Cayman Islands KY1-9008, Cayman Islands.
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionDisclaimer;